/* --------------------------------------------------------------------------
	Home Feature
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	var Raf, LastScrollTop, ContentHeight, ScrollTop;

	function init() {
		if (!$('.js-feature').length) {
			return;
		}

		$(function () {
			$('.js-feature-jumps').addClass('ready');
		});

		Raf = window.requestAnimationFrame;
		LastScrollTop = window.pageYOffset;
		ContentHeight = $('.js-feature-header-content').innerHeight();

		scrollLoop();
		onScroll();

		Site.OnResize.push(onResize);

		$('.js-feature-header-toggle').attr('role', 'button').on('click', onToggleClick);
		$('.js-feature-control-pause').on('click', onPauseClick);
		$('.js-feature-control-play').on('click', onPlayClick);
		$('.js-feature-control-mute').on('click', onMuteClick);
		$('.js-feature-control-unmute').on('click', onUnmuteClick);
	}

	function onToggleClick() {
		$('.js-feature').addClass('rolling');
		$('.js-feature-media-video-background').trigger('pause');
		$('.js-feature-media-video-foreground').transition({ always: false, property: 'opacity' }, function () {
			$('.js-feature-media-video-foreground').trigger('play');
		});
	}

	function onPauseClick() {
		$('.js-feature-media-video-foreground').trigger('pause');
		$('.js-feature-control-pause').removeClass('active');
		$('.js-feature-control-play').addClass('active');
	}

	function onPlayClick() {
		$('.js-feature-media-video-foreground').trigger('play');
		$('.js-feature-control-play').removeClass('active');
		$('.js-feature-control-pause').addClass('active');
	}

	function onMuteClick() {
		$('.js-feature-media-video-foreground').prop('muted', true);
		$('.js-feature-control-mute').removeClass('active');
		$('.js-feature-control-unmute').addClass('active');
	}

	function onUnmuteClick() {
		$('.js-feature-media-video-foreground').prop('muted', false);
		$('.js-feature-control-unmute').removeClass('active');
		$('.js-feature-control-mute').addClass('active');
	}

	function scrollLoop() {
		ScrollTop = window.pageYOffset;

		if (LastScrollTop === ScrollTop) {
			Raf(scrollLoop);

			return;
		} else {
			LastScrollTop = ScrollTop;

			onScroll();
			Raf(scrollLoop);
		}
	}

	function onScroll() {
		if ($(window).width() >= Site.MinLG && $(window).width() < Site.MinXL) {
			if (ScrollTop > 1500) {
				ScrollTop = 1500;
			}
		} else if ($(window).width() >= Site.MinXL) {
			if (ScrollTop > 1350) {
				ScrollTop = 1350;
			}
		}

		$('.js-feature-header-content-decoration').height(ContentHeight + ScrollTop);
	}

	function onResize() {
		ContentHeight = $('.js-feature-header-content').innerHeight();
		onScroll();
	}

	Site.OnInit.push(init);
})(jQuery, Site);
